<template>
  <div class="card ml-20 mr-20" style="height: 100vh">
    <div class="card-header">
      <div class="card-header">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="javascript:void(0)">LXD</a>
            </li>
            <li class="breadcrumb-item">
              <a href="javascript:void(0)">Create Instance</a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <template v-if="!showSuccess">
          <div class="col-md-12 d-flex justify-content-center align-items-center">
            <h5 class="fw-600">Create Instance</h5>
          </div>
          <div class="col-md-3">
          </div>
          <div class="col-md-6">
            <form class="form-horizontal" @submit.prevent="submitForm">
              <div class="row">
                <label class="col-md-3 col-form-label">Name</label>
                <div class="col-md-9">
                  <div class="form-group">
                    <input v-model="form.name" class="form-control"
                           placeholder="Name" required type="text">
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-md-3 col-form-label">Hostname</label>
                <div class="col-md-9">
                  <div class="form-group">
                    <input v-model="form.hostname" class="form-control" placeholder="Hostname" required type="text">
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-md-3 col-form-label">Image</label>
                <div class="col-md-9">
                  <div class="form-group">
                    <select v-model="form.image" class="form-control">
                      <option disabled value="">Select</option>
                      <option value="wpo">WPO</option>
                      <option value="alma9-bs">Alma 9</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-md-3 col-form-label">Profile</label>
                <div class="col-md-9">
                  <div class="form-group">
                    <select v-model="form.profile" class="form-control">
                      <option disabled value="">Select</option>
                      <option value="wpo-starter">WPO Starter</option>
                      <option value="wpo-pro">WPO Professional</option>
                      <option value="wpo-business">WPO Business</option>
                      <option value="wpo-enterprise">WPO Enterprise</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <label class="col-md-3 col-form-label">Cluster</label>
                <div class="col-md-9">
                  <div class="form-group">
                    <select v-model="cluster" class="form-control">
                      <option disabled value="">Select</option>
                      <option value="lx4">LX4 (Testing)</option>
                      <option value="ord">ORD (Production)</option>
                      <option value="egv">EGV (Production)</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-9 d-flex justify-content-end pr-60 align-items-center">
                  <button :disabled="loading" class="btn btn-info pull-right" type="submit">
                    <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                    <span v-else>Create</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </template>
        <div v-if="showSuccess" class="col-md-12">
          <svg class="checkmark" viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" fill="none" r="25"/>
            <path class="checkmark-check" d="M14 27l7 7 16-16" fill="none"/>
          </svg>
          <h4 class="text-center fw-600">Instance Created Successfully</h4>
          <p class="text-center">
            Press a button below to either create a new instance or view the current instance you just created.
          </p>
          <div class="d-flex justify-content-center">
            <button class="btn btn-outline-info" @click="openForm">Create New Instance</button>
            <button class="ml-20 btn btn-danger btn-outline-danger"
                    @click="viewCurrentInstance">View Current Instance
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "create.vue",
  data() {
    return {
      showSuccess: false,
      loading: false,
      cluster: 'lx4',
      form: {
        name: '',
        image: 'wpo',
        profile: 'wpo-starter',
      }
    }
  },
  methods: {
    openForm() {
      this.showSuccess = false;
      this.form.name = '';
      this.form.hostname = '';
    },
    viewCurrentInstance() {
      localStorage.setItem('cluster', this.cluster)
      this.$router.push({name: 'lxd-details', params: {id: this.form.name}});
    },
    async submitForm() {
      try {
        if (!this.form.name || !this.form.hostname) {
          return
        }
        this.loading = true;
        const resp = await this.$http.post('/lxd/instance/action', {
          action: 'create',
          data: {
            ...this.form
          },
          cluster: this.cluster,
          grant_type: 'token'
        })
        if (resp.data.success) {
          this.showSuccess = true
        } else {
          this.showToast({
            message: `Something went wrong while creating instance. ${e.toString()}`,
            duration: 2000
          }, true, 'danger')
        }
      } catch (e) {
        console.log(e)
        this.showToast({
          message: `Something went wrong while creating instance. ${e.toString()}`,
          duration: 2000
        }, true, 'danger')
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>


<style scoped>
/* Animated Checkmark */
.checkmark {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  stroke-width: 3;
  stroke: #22c55e;
  stroke-miterlimit: 10;
  border-radius: 50%;
  display: block;
}

.checkmark-circle {
  stroke-dasharray: 157;
  stroke-dashoffset: 157;
  stroke: #22c55e;
  animation: circleDraw 0.7s ease-in-out forwards;
}

.checkmark-check {
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke: #22c55e;
  animation: checkDraw 0.5s ease-in-out forwards;
  animation-delay: 0.7s;
}

@keyframes circleDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes checkDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes pop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

label {
  font-weight: bold;
  color: gray;
}
</style>
